import { useToast, ToastVariant } from '@SBGSports/catapult-core';
import * as React from 'react';

export const useShowAlert = () => {
    const alertKey = React.useRef<string>();
    const { showToast, hideToast } = useToast();

    return React.useCallback(
        (title: string, content: React.ReactNode, variant?: ToastVariant | undefined, onClose?: () => void) => {
            const key = crypto.randomUUID();

            if (alertKey.current) {
                hideToast(alertKey.current);
            }

            showToast({
                message: title,
                description: content,
                type: variant ?? 'alert',
                duration: 10000,
                onClose,
                key,
            });

            alertKey.current = key;
        },
        [showToast, hideToast],
    );
};
